import { useState } from "react";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const CustomSlider = () => {
  const [isPrevSecDisabled, setIsPrevSecDisabled] = useState(true);
  const [isNextSecDisabled, setIsNextSecDisabled] = useState(false);

  const handleSlideSecChange = (swiper) => {
    setIsPrevSecDisabled(swiper.isBeginning);
    setIsNextSecDisabled(swiper.isEnd);
  };

  return (
    <div>
      <div className="why-custom-swiper">
        <Swiper
          spaceBetween={12}
          slidesPerView={4}
          modules={[Navigation, A11y, Pagination]}
          pagination={{
            clickable: true,
            // el: ".forex-paginate",
          }}
          scrollbar={{ draggable: true }}
          navigation={{
            prevEl: ".why-custom-prev-arrow",
            nextEl: ".why-custom-next-arrow",
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            480: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1025: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          }}
          onSlideChange={handleSlideSecChange}
          onReachBeginning={() => setIsPrevSecDisabled(true)}
          onReachEnd={() => setIsNextSecDisabled(true)}
          onFromEdge={() => {
            setIsPrevSecDisabled(false);
            setIsNextSecDisabled(false);
          }}
        >
          <SwiperSlide>
            <div className="why-custom-card-one">
              <img
                src={require("../../../image/custom-software/b-blue.webp")}
                alt="Custom Software Development Company"
                className="why-custom-img"
              />
              <h6>Our Custom Software Development Process</h6>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="why-custom-card">
              <img
                src={require("../../../image/custom-software/custom-slide-one.webp")}
                alt="Custom Software Development Company"
              />
              <h6>Requirement Analysis</h6>
              <p>
                We collaborate with you to gain a clear understanding of your
                business objectives and technical needs.
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="why-custom-card">
              <img
                src={require("../../../image/custom-software/custom-slide-two.webp")}
                alt="Custom Software Development Company"
              />
              <h6>Design and Prototyping</h6>
              <p>
                Create user-friendly designs and prototypes for seamless user
                experiences.
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="why-custom-card">
              <img
                src={require("../../../image/custom-software/custom-slide-three.webp")}
                alt="Custom Software Development Company"
              />
              <h6>Development</h6>
              <p>
                Build robust, scalable, and secure software solutions using the
                latest technologies.
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="why-custom-card">
              <img
                src={require("../../../image/custom-software/custom-slide-four.webp")}
                alt="Custom Software Development Company"
              />
              <h6>Testing and Deployment</h6>
              <p>Conduct thorough testing to ensure bug-free deployment.</p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="why-custom-card">
              <img
                src={require("../../../image/custom-software/custom-slide-five.webp")}
                alt="Custom Software Development Company"
              />
              <h6>Support and Maintenance</h6>
              <p>
                Provide ongoing support to enhance performance and scalability.
              </p>
            </div>
          </SwiperSlide>
        </Swiper>

        <div className="why-custom-btn-wrapper">
          <button
            className={`why-custom-prev-arrow ${
              isPrevSecDisabled ? "disabled" : ""
            }`}
            style={{
              color: isPrevSecDisabled ? "#0000215c" : "#000021",
              cursor: isPrevSecDisabled ? "not-allowed" : "pointer",
            }}
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <button
            className={`why-custom-next-arrow ${
              isNextSecDisabled ? "disabled" : ""
            }`}
            style={{
              color: isNextSecDisabled ? "#0000215c" : "#000021",
              cursor: isNextSecDisabled ? "not-allowed" : "pointer",
            }}
          >
            <i className="fa-solid fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomSlider;
